import { defineLevel } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   MONDE 3 · NIVEAU 3 — LE COLOSSE.

     0:00  bloc G2       14 s   rappel
     0:14  boss           —     le Colosse

   DERNIER niveau de la campagne : il porte le boss final. Le Colosse repose une
   dernière fois la question du monde — quelle cible mérite d'être détruite —
   avec un noyau atteignable dès la première seconde.

   ⚠️ G2 (14 s) démarre à 0 et se termine quand le bloc de boss s'ouvre à 0:14.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineLevel({
  id: 'monde-3-3',
  // 14 s de rappel + 120 s de marge pour le combat final.
  duration: 134,
  blocks: [
    { at: 0, wave: 'g2-rappel' },
    { at: 14, wave: 'boss-colosse' },
  ],
});
